// extracted by mini-css-extract-plugin
export default {"kycRequestedPreview":"J4Zbu"};